import { render } from "./materialShed.vue?vue&type=template&id=9654a27a&scoped=true"
import script from "./materialShed.vue?vue&type=script&lang=js"
export * from "./materialShed.vue?vue&type=script&lang=js"

import "./materialShed.vue?vue&type=style&index=0&id=9654a27a&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9654a27a"]])

export default __exports__